import { Player } from "@lottiefiles/react-lottie-player"
import { Button } from "@mui/material"
import { GlobalStateContext } from "GlobalState"
import classNames from "classnames"
import { AnimatePresence, motion } from "framer-motion"
import utils from 'modules/utils'
import { useContext, useEffect, useMemo, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import css from "./BottomNavBar.module.scss"

export const BottomNavBar = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [isFirstRender, setIsFirstRender] = useState(true)
  const { showBottomNavBar } = useContext(GlobalStateContext)
  const [discoverLottie, setDiscoverLottie] = useState()
  const [searchLottie, setSearchLottie] = useState()
  const [playLottie, setPlayLottie] = useState()

  const navbarLinks = useMemo(() => [
    {
      label: "Discover",
      linkTo: "/play",
      className: "discoverBtn",
      lottieSize: 24,
      lottie: "/lottie/discovery_icon.json",
      lottieInstance: discoverLottie,
      setLottieInstance: setDiscoverLottie
    },
    {
      label: null,
      linkTo: "/play",
      className: "searchBtn",
      lottieSize: 30,
      lottie: "/lottie/search_icon.json",
      lottieInstance: searchLottie,
      setLottieInstance: setSearchLottie
    },
    {
      label: "Play",
      linkTo: "/play",
      className: "playBtn",
      lottieSize: 24,
      lottie: "/lottie/controller_icon.json",
      lottieInstance: playLottie,
      setLottieInstance: setPlayLottie
    },
  ], [discoverLottie, playLottie, searchLottie])

  // Super Ugly hack to set the initial state of the icon when the page loads
  useEffect(() => {
    setTimeout(() => {
      navbarLinks.forEach(({ linkTo, lottieInstance }) => {
        if (!lottieInstance) return

        if (location.pathname.startsWith(linkTo)) {
          if (lottieInstance.currentFrame === 0) {
            if (isFirstRender) {
              lottieInstance.goToAndStop(lottieInstance.totalFrames - 1, true)
              setIsFirstRender(false)
            } else {
              lottieInstance.goToAndPlay(0, true)
            }
          }
        } else {
          lottieInstance.goToAndStop(0, true)
        }
      });
    }, 1);
  }, [location, navbarLinks, isFirstRender])

  return (
    <AnimatePresence>
      {showBottomNavBar && <motion.div
        className={css.bottomNavBar}
        padding="lr-lg"
        sf="mc"
        initial={{ opacity: 0, marginBottom: "-4.5rem" }}
        animate={{ opacity: 1, marginBottom: 0 }}
        exit={{ opacity: 0, marginBottom: "-4.5rem" }}
        transition={{ duration: 0.5 }}
      >
        {navbarLinks.map(({ linkTo, lottieSize, lottie, setLottieInstance, label, className }, i) => (
          <div key={i} col={1} className={classNames(css.tab, css[className])}>
            <Button
              className={classNames(css.button, css[className], {
                [css.selected]: location.pathname.includes(linkTo),
              })}
              sf="col mc"
              onClick={() => navigate(linkTo)}
            >
              <Player
                lottieRef={instance => setLottieInstance(instance)}
                src={utils.fetchLottie(lottie)}
                keepLastFrame={true}
                style={{
                  width: lottieSize,
                  height: lottieSize,
                }}
              />

              {label && <div>{label}</div>}
            </Button>
          </div>
        ))}
      </motion.div>}
    </AnimatePresence>
  )
}
